var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden"},style:({
    margin: _vm.margin,
    borderRadius: _vm.hasBorder ? _vm.borderRadius : null,
    border: _vm.hasBorder ? _vm.border : null,
    textAlign: _vm.textAlign,
    width: _vm.width,
    padding: _vm.padding,
    background: _vm.backgroundGradient
      ? ("radial-gradient(ellipse at center bottom, " + (_vm.backgroundGradient.int) + " 0%, " + (_vm.backgroundGradient.ext) + " 200%)")
      : null,
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }